<template>
  <div
    v-if="role"
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu v-if="user.name" :title="user"></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <!-- <sidebar-item
          v-if="$route.meta.rtlActive"
          :link="{
            name: 'لوحة القيادةة',
            icon: 'dashboard',
            path: '/dashboard',
          }"
        />
        <sidebar-item
          v-else
          :link="{ name: 'Dashboard', icon: 'dashboard', path: '/dashboard' }"
        /> -->
        <sidebar-item
          :link="{ path: '/home', name: 'Home Page', icon: 'home' }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="user && check_object_value(user.role_name, 'name', ['Admin'])"
          :opened="
            check_object_value(user.role_name, 'division_id', [1])
              ? true
              : false
          "
          :link="{ name: 'Admin', icon: 'admin_panel_settings' }"
        >
          <sidebar-item
            v-if="role['User'] && role['User'].menu == 1"
            :link="{
              name: 'User Management',
              path: '/admin/user-management/list-users',
            }"
          />
          <sidebar-item
            v-if="role['Role'] && role['Role'].menu == 1"
            :link="{
              name: 'Role',
              path: '/admin/role/list-role',
            }"
          />
        </sidebar-item>

        <sidebar-item
          v-if="
            user &&
              check_object_value(user.role_name, 'division_id', [3, 1, 6, 8])
          "
          :opened="
            check_object_value(user.role_name, 'division_id', [3])
              ? true
              : false
          "
          :link="{ name: 'DMS', icon: 'hub' }"
        >
          <sidebar-item
            :link="{
              name: 'Dashboard DMS',
              icon: 'dashboard',
              path: '/fms/dashboard',
            }"
          />
            <sidebar-item
              style="margin-left:5mm !important"
              v-if="
                role['FmsDrivers'] && role['FmsDrivers'].menu == 1
              "
              :link="{
                name: 'Driver',
                path: '/Fms/list-driver',
              }"
            />
            <sidebar-item
              style="margin-left:5mm !important"
              v-if="
                role['FmsPkos'] && role['FmsPkos'].menu == 1
              "
              :link="{
                name: 'PKO',
                path: '/Fms/list-pko',
              }"
            />

            <sidebar-item
              style="margin-left:5mm !important"
              v-if="
                role['FmsSpjs'] && role['FmsSpjs'].menu == 1
              "
              :link="{
                name: 'SPJ',
                path: '/Fms/list-spj',
              }"
            />
            <sidebar-item
              style="margin-left:5mm !important"
              v-if="
                role['FmsVehicles'] && role['FmsVehicles'].menu == 1
              "
              :link="{
                name: 'Vehicle',
                path: '/Fms/list-vehicle',
              }"
            />
            <sidebar-item
              style="margin-left:5mm !important"
              v-if="
                role['FmsCitys'] && role['FmsCitys'].menu == 1
              "
              :link="{
                name: 'City',
                path: '/Fms/list-city',
              }"
            />
            <sidebar-item
              style="margin-left:5mm !important"
              v-if="
                role['FmsDpAmounts'] && role['FmsDpAmounts'].menu == 1
              "
              :link="{
                name: 'Dp Amount',
                path: '/Fms/list-dp-amount',
              }"
            />
            <sidebar-item
              style="margin-left:5mm !important"
              v-if="
                role['FmsPaymentPlans'] && role['FmsPaymentPlans'].menu == 1
              "
              :link="{
                name: 'Payment Plan',
                path: '/Fms/list-payment-plan',
              }"
            />
            <!-- <sidebar-item
              style="margin-left:5mm !important"
              v-if="
                role['FmsBusinessUnits'] && role['FmsBusinessUnits'].menu == 1
              "
              :link="{
                name: 'Business Unit',
                path: '/Fms/list-business-unit',
              }"
            /> -->
            <sidebar-item
              style="margin-left:5mm !important"
              v-if="
                role['FmsCashiers'] && role['FmsCashiers'].menu == 1
              "
              :link="{
                name: 'Cashier',
                path: '/Fms/list-cashier',
              }"
            />
          </sidebar-item>
        <!-- <sidebar-item opened :link="{ name: 'Examples (API)', image: image }">
          <sidebar-item
            :link="{ name: 'User Profile', path: '/examples/user-profile' }"
          />
          <sidebar-item
            :link="{
              name: 'User Management',
              path: '/examples/user-management/list-users',
            }"
          />
        </sidebar-item> -->
        

          <sidebar-item
            v-if="
                (role['WorkshopAudits'] && role['WorkshopAudits'].menu == 1) ||
                (role['WorkshopDailyClosings'] &&
                  role['WorkshopDailyClosings'].menu == 1) ||
                (role['WorkshopParkings'] &&
                  role['WorkshopParkings'].menu == 1) ||
                (role['WorkshopParkingLines'] &&
                  role['WorkshopParkingLines'].menu == 1) ||
                (role['WorkshopServiceCategories'] &&
                  role['WorkshopServiceCategories'].menu == 1) ||
                (role['WorkshopServiceMasters'] &&
                  role['WorkshopServiceMasters'].menu == 1) ||
                (role['WorkshopPartDealers'] &&
                  role['WorkshopPartDealers'].menu == 1) ||
                (role['WorkshopProcurementOrders'] &&
                  role['WorkshopProcurementOrders'].menu == 1) ||
                (role['WorkshopSparePartMasters'] &&
                  role['WorkshopSparePartMasters'].menu == 1) ||
                (role['WorkshopClientMasters'] &&
                  role['WorkshopClientMasters'].menu == 1) ||
                (role['WorkshopServiceEstimates'] &&
                  role['WorkshopServiceEstimates'].menu == 1) ||
                (role['WorkshopPkbs'] && role['WorkshopPkbs'].menu == 1) ||
                (role['WorkshopFakturs'] &&
                  role['WorkshopFakturs'].menu == 1) ||
                (role['WorkshopNotaParts'] &&
                  role['WorkshopNotaParts'].menu == 1) ||
                (role['WorkshopNotaJasaBkls'] &&
                  role['WorkshopNotaJasaBkls'].menu == 1)
            "
           
            :link="{
              name: 'Workshop',
              icon: 'construction'
            }"
          >
            <sidebar-item
              :link="{
                name: 'Dashboard Workshop',
                icon: 'dashboard',
                path: '/workshop/dashboard',
              }"
            />

            <sidebar-item
              v-if="role['WorkshopAudits'] && role['WorkshopAudits'].menu == 1"
              style="margin-left:5mm !important"
              :link="{ name: 'Audit' }"
            >
              <sidebar-item
                style="margin-left:5mm !important"
                v-if="
                  role['WorkshopAudits'] && role['WorkshopAudits'].menu == 1
                "
                :link="{
                  name: 'Audit Sparepart',
                  path: '/workshop/audit/list-audit-sparepart',
                }"
              />
              <sidebar-item
                style="margin-left:5mm !important"
                v-if="
                  role['WorkshopAudits'] && role['WorkshopAudits'].menu == 1
                "
                :link="{
                  name: 'Audit Vehicle Sparepart',
                  path: '/workshop/audit/list-audit-vehicle-sparepart',
                }"
              />

            </sidebar-item>

            <sidebar-item
              v-if="
                role['WorkshopDailyClosings'] &&
                  role['WorkshopDailyClosings'].menu == 1
              "
              :link="{
                name: 'Daily Closing',
                path: '/workshop/daily-closing/list-daily-closing',
              }"
            />

            <sidebar-item
              v-if="
                role['WorkshopParkings'] && role['WorkshopParkings'].menu == 1
              "
              :link="{
                name: 'Parking',
                path: '/workshop/parking/list-parking',
              }"
            />

            <sidebar-item
              v-if="
                role['WorkshopParkingLines'] &&
                  role['WorkshopParkingLines'].menu == 1
              "
              :link="{
                name: 'Parking Line',
                path: '/workshop/parking-line/list-parking-line',
              }"
            />

            <sidebar-item
              v-if="
                role['WorkshopServiceCategories'] &&
                  role['WorkshopServiceCategories'].menu == 1
              "
              :link="{
                name: 'Service Categories',
                path: '/workshop/service-categories/list-service-categories',
              }"
            />
          
            <sidebar-item
              v-if="
                role['WorkshopServiceMasters'] &&
                  role['WorkshopServiceMasters'].menu == 1
              "
              :link="{
                name: 'Service Master',
                path: '/workshop/service-master/list-service-master',
              }"
            />
            <sidebar-item
              v-if="
                role['WorkshopPartDealers'] &&
                  role['WorkshopPartDealers'].menu == 1
              "
              :link="{
                name: 'Part Dealer',
                path: '/workshop/part-dealer/list-part-dealer',
              }"
            />
            <sidebar-item
              v-if="
                role['WorkshopProcurementOrders'] &&
                  role['WorkshopProcurementOrders'].menu == 1
              "
              :link="{
                name: 'Procurement Order',
                path: '/workshop/procurement-order/list-procurement-order',
              }"
            />

            <sidebar-item
              v-if="
                role['WorkshopSparePartMasters'] &&
                  role['WorkshopSparePartMasters'].menu == 1
              "
              style="margin-left:5mm !important"
              :link="{ name: 'Spare Part' }"
            >
              <sidebar-item
                v-if="
                  role['WorkshopSparePartMasters'] &&
                    role['WorkshopSparePartMasters'].menu == 1
                "
                :link="{
                  name: 'Spare Part Master',
                  path: '/workshop/spare-part-master/list-spare-part-master',
                }"
              />

              <sidebar-item
                v-if="
                  role['WorkshopSparePartRequests'] &&
                    role['WorkshopSparePartRequests'].menu == 1
                "
                :link="{
                  name: 'Spare Part Request',
                  path: '/workshop/spare-part-request/list-spare-part-request',
                }"
              />
              <sidebar-item
                v-if="
                  role['WorkshopSparePartTransfers'] &&
                    role['WorkshopSparePartTransfers'].menu == 1
                "
                :link="{
                  name: 'Spare Part Transfer',
                  path:
                    '/workshop/spare-part-transfer/list-spare-part-transfer',
                }"
              />
            </sidebar-item>

            <sidebar-item
              v-if="
                role['WorkshopClientMasters'] &&
                  role['WorkshopClientMasters'].menu == 1
              "
              :link="{
                name: 'Client Master',
                path: '/workshop/client-master/list-client-master',
              }"
            />
            <sidebar-item
              v-if="
                role['WorkshopServiceEstimates'] &&
                  role['WorkshopServiceEstimates'].menu == 1
              "
              :link="{
                name: 'Service Estimate',
                path: '/workshop/service-estimate/list-service-estimate',
              }"
            />
            <sidebar-item
              v-if="role['WorkshopPkbs'] && role['WorkshopPkbs'].menu == 1"
              :link="{
                name: 'PKB',
                path: '/workshop/pkb/list-pkb',
              }"
            />
            <sidebar-item
              v-if="
                role['WorkshopFakturs'] && role['WorkshopFakturs'].menu == 1
              "
              :link="{
                name: 'Faktur',
                path: '/workshop/faktur/list-faktur',
              }"
            />

            <sidebar-item
              v-if="
                role['WorkshopNotaParts'] && role['WorkshopNotaParts'].menu == 1
              "
              :link="{
                name: 'Nota Part',
                path: '/workshop/nota-part/list-nota-part',
              }"
            />

            <sidebar-item
              v-if="
                role['WorkshopNotaJasaBkls'] &&
                  role['WorkshopNotaJasaBkls'].menu == 1
              "
              :link="{
                name: 'Nota Jasa Bkl',
                path: '/workshop/nota-jasa-bkl/list-nota-jasa-bkl',
              }"
            />

            <!-- <sidebar-item  v-if="role['WorkshopVehicles'] && role['WorkshopVehicles'].menu == 1" 
          
            :link="{  
              name: 'Vehicle',
              path: '/workshop/vehicle/list-vehicle',  
            }"
          />

            <sidebar-item  v-if="role['WorkshopVehicleTypes'] && role['WorkshopVehicleTypes'].menu == 1" 
          
            :link="{  
              name: 'Vehicle Type',
              path: '/workshop/vehicle-type/list-vehicle-type',  
            }"
          /> -->

            <!-- <sidebar-item  v-if="role['WorkshopBusinessUnits'] && role['WorkshopBusinessUnits'].menu == 1" 
          
            :link="{  
              name: 'Business Unit',
              path: '/workshop/business-unit/list-business-unit',  
            }"
          /> -->
          </sidebar-item>

          
          <sidebar-item
            v-if="
                role['FinanceClicks'] &&
                  role['FinanceClicks'].menu == 1
              "
            :link="{
              name: 'Finance',
              icon: 'money'
            }"
          >
            <sidebar-item
              v-if="
                  role['FinanceClicks'] &&
                    role['FinanceClicks'].menu == 1
                "
              :link="{
                name: 'Click',
                icon: 'money',
                path: '/finance/click/list-click',
              }"
            />
          </sidebar-item>

        <!-- <sidebar-item  v-if="user && check_object_value(user.role_name, 'name', ['Admin'])" :opened="check_object_value(user.role_name, 'division_id', [1]) ? true : false"  :link="{ path: '/landing', name: 'Landing Page', icon: 'admin_panel_settings'}">
          
          </sidebar-item> -->
        <!-- 
        <sidebar-item
          v-if="$route.meta.rtlActive"
          :link="{
            name: 'الجداول',
            icon: 'content_paste',
            path: '/components/table',
          }"
        />
        <sidebar-item
          :link="{
            name: 'Table Lists',
            icon: 'content_paste',
            path: '/components/table',
          }"
        /> -->

        <!-- <sidebar-item
          v-if="$route.meta.rtlActive"
          :link="{
            name: 'طباعة',
            icon: 'library_books',
            path: '/components/typography',
          }"
        />
        <sidebar-item
          v-else
          :link="{
            name: 'Typography',
            icon: 'library_books',
            path: '/components/typography',
          }"
        /> -->
        <!-- 
        <sidebar-item
          v-if="$route.meta.rtlActive"
          :link="{
            name: 'الرموز',
            icon: 'bubble_chart',
            path: '/components/icons',
          }"
        />
        <sidebar-item
          v-else
          :link="{
            name: 'Icons',
            icon: 'bubble_chart',
            path: '/components/icons',
          }"
        />

        <sidebar-item
          v-if="$route.meta.rtlActive"
          :link="{
            name: 'خرائط جوجل',
            icon: 'place',
            path: '/components/maps',
          }"
        />
        <sidebar-item
          v-else
          :link="{ name: 'Maps', icon: 'place', path: '/components/maps' }"
        />

        <sidebar-item
          v-if="$route.meta.rtlActive"
          :link="{
            name: 'إخطارات',
            icon: 'notifications',
            path: '/components/notifications',
          }"
        />
        <sidebar-item
          v-else
          :link="{
            name: 'Notifications',
            icon: 'notifications',
            path: '/components/notifications',
          }"
        />

        <sidebar-item
          v-if="$route.meta.rtlActive"
          :link="{ name: 'دعم رتل', icon: 'language', path: '/components/rtl' }"
        />
        <sidebar-item
          v-else
          :link="{
            name: 'RTL Support',
            icon: 'language',
            path: '/components/rtl',
          }"
        /> -->
      </template>

      <!-- <div style="width: 100%; position: absolute; bottom: 0; padding: 16px">
        <md-button
          v-if="sidebarMini"
          class="md-button md-danger md-block"
          href="https://www.creative-tim.com/product/vue-material-dashboard-laravel-pro"
          target="_blanck"
        >
          <i class="fas fa-download" style="margin-right: 4px"></i>Upgrade to
          PRO
        </md-button>
      </div> -->
    </side-bar>

    <div class="main-panel">
      <top-navbar
        :notification="user.notification"
        :user="user"
        v-if="user.notification"
      ></top-navbar>

      <fixed-plugin
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin>

      <div :class="{ content: !$route.meta.hideContent }">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view />
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    //console.log("initScrollbar");
    new PerfectScrollbar(`.${className}`, {
      wheelSpeed: 0.2,
      wheelPropagation: false,
      minScrollbarLength: 2,
    });
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  //   // console.log("reinitScrollbar");
  // if (isWindows) {
  //   // if we are on windows OS we activate the perfectScrollbar function
  //   initScrollbar("sidebar");
  //   initScrollbar("sidebar-wrapper");
  //   initScrollbar("main-panel");
  //   docClasses.add("perfect-scrollbar-on");
  // } else {
  //   docClasses.add("perfect-scrollbar-off");
  // }
  initScrollbar("sidebar");
  initScrollbar("sidebar-wrapper");
  // initScrollbar("main-panel");
  docClasses.add("perfect-scrollbar-on");
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    FixedPlugin,
    MobileMenu,
    UserMenu,
  },

  data() {
    return {
      user: "",
      division: null,
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + "/img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + "/img/laravel-vue.svg",
      role: "",
    };
  },

  async created() {
    this.getData();
  },
  computed: {
    // isAuthenticated()
    // {
    //   return this.role == 'Admin' ;
    // }
  },

  methods: {
    async getData() {
      //  await this.$store.watch(() => this.$store.getters["profile/me"], (me) => {
      //     this.user = me,
      //     this.role = me.role
      //     console.log(me.name)
      //   })
      // await this.$store.dispatch("profile/me")
      if (
        !this.$store.getters["profile/me"] ||
        Object.keys(this.$store.getters["profile/me"]).length == 0
      ) {
        //minta data me ke server lalu save ke store profile me
        await this.$store.dispatch("profile/me");
      }
      var me = await this.$store.getters["profile/me"];
      console.log(me);
      if (!me) {
        return;
      }
      this.division = me.role_name.division_id;
      this.role = me.role;
      this.user = me;
      this.user.role_name.name_string = this.role_name(
        this.user.role_name
      ).toString();

      // console.log(this.user.id)
      // console.log(this.check_object_value_division(this.user.role_name, 'supervisor_id', [parseInt(this.user.id)]))
      // console.log("aaaaaaaaaaaaaa")

      // console.log(this.user.role_name)
      // console.log(this.$route)
      // console.log("yayayaya");
    },

    check_object_value(array, key, value) {
      // console.log(array);
      // console.log(key);
      // console.log(value);
      //return array.some(object => object[key] === value);
      return array.some((object) => value.includes(object[key]));
    },

    check_object_value_division(array, key, value) {
      var result = array.map((v, index) => ({ ...v.division }));
      return result.some((object) => value.includes(object[key]));
    },

    role_name(data) {
      // console.log(data);
      return data.map(function(data) {
        return data.name;
      });
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
